"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/* ++++++++++ --------------- COPY FIELD : DEFINITION --------------- ++++++++++ */

var _default2 = {
  name: 'IncDecField',
  props: {
    name: {
      type: 'string',
      default: 'incdecfield'
    },
    defaultValue: {
      type: 'number',
      default: 10
    },
    increment: {
      type: 'number',
      default: 1
    },
    minValue: {
      type: 'number',
      default: 5
    },
    maxValue: {
      type: 'number',
      default: 10
    },
    handleIncToggle: {
      type: 'function',
      default: function _default(currentValue) {
        return console.log('handleIncToggle called: ', currentValue);
      }
    },
    handleDecToggle: {
      type: 'function',
      default: function _default(currentValue) {
        return console.log('handleDecToggle called: ', currentValue);
      }
    },
    handleChange: {
      type: 'function',
      default: function _default(val) {
        return console.log('handleChange called: ', val);
      }
    },
    ctaPosition: {
      type: 'string',
      default: 'inline',
      options: ['inline', 'block']
    },
    disabled: {
      type: 'boolean',
      default: false,
      options: [true, false]
    }
  }
};
exports.default = _default2;